import { render } from "./TablaResultados.vue?vue&type=template&id=7d6ebe8f&scoped=true"
import script from "./TablaResultados.vue?vue&type=script&lang=js"
export * from "./TablaResultados.vue?vue&type=script&lang=js"

import "./TablaResultados.vue?vue&type=style&index=0&id=7d6ebe8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6ebe8f"]])

export default __exports__